import { useSearchParams } from "react-router-dom";
import Header from "@/sections/Header";
import FeaturedIn from "@/sections/FeaturedIn";
import { HeroClassic } from "@/components/hero/HeroClassic";
import { HeroOptionB } from "@/components/hero/HeroOptionB";
import { HeroOptionB2 } from "@/components/hero/HeroOptionB2";
import { HeroOptionB4 } from "@/components/hero/HeroOptionB4";
import { HeroOptionB5 } from "@/components/hero/HeroOptionB5";
import { PreviewToolbar, useNoIndex } from "@/components/preview/PreviewToolbar";

const OPTIONS = [
  { id: "b", label: "B · Split + Live Stats", short: "B · Split", blurb: "Copy on the left under the horizontal logo. The icon mark sits on the right inside a live index of open roles, employer feeds and infrastructure stocks.", Component: HeroOptionB },
  { id: "b2", label: "B2 · Orbit Stats", short: "B2 · Orbit", blurb: "The icon mark sits at the center with the four live stats placed around it like data points, linked by flowing lines.", Component: HeroOptionB2 },
  { id: "b4", label: "B4 · Ticker Band (Live)", short: "B4 · Live", blurb: "A larger floating icon mark on the left, a live stats strip across the hero, and a scrolling band of digital infrastructure stocks.", Component: HeroOptionB4 },
  { id: "b5", label: "B5 · Job Pulse", short: "B5 · Jobs", blurb: "The icon mark with live open-role counts and a feed of the newest roles, so the hero says 'jobs' at first glance.", Component: HeroOptionB5 },
  { id: "previous", label: "Previous", short: "Previous", blurb: "The previous homepage hero, kept for comparison.", Component: HeroClassic },
];

export default function HeroOptionsPage() {
  const [params, setParams] = useSearchParams();
  const active = OPTIONS.find((option) => option.id === params.get("option")) || OPTIONS[0];
  useNoIndex("Homepage Hero Options · DCYB Private Preview");
  const select = (id) => { setParams({ option: id }, { replace: true }); window.scrollTo({ top: 0 }); };
  const { Component } = active;
  return (
    <main data-testid="hero-options-page" className="relative">
      <Header />
      <PreviewToolbar heading="Private preview · Homepage hero options" options={OPTIONS} active={active} onSelect={select} />
      <div data-testid={`hero-options-preview-${active.id}`} key={active.id}><Component /></div>
      <FeaturedIn />
    </main>
  );
}
